import { render, staticRenderFns } from "./closedList.vue?vue&type=template&id=c19f1e12"
import script from "./closedList.vue?vue&type=script&lang=js"
export * from "./closedList.vue?vue&type=script&lang=js"
import style0 from "./closedList.vue?vue&type=style&index=0&id=c19f1e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports